import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTheme as useCustomTheme } from '../context/ThemeContext';
import ThreeBackground from './ThreeBackground';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const theme = useTheme();
  const { activeThemeDefinition } = useCustomTheme();

  // Déterminer le fond (couleur unie ou dégradé) du thème actif
  const colors = activeThemeDefinition?.colors;
  let backgroundValue = theme.palette.background.default;

  if (colors?.background) {
    const bg = colors.background;
    if (bg.mode === 'gradient') {
      if (bg.gradientType === 'radial') {
        backgroundValue = `radial-gradient(circle, ${bg.color1} ${bg.stop1}%, ${bg.color2} ${bg.stop2}%)`;
      } else {
        backgroundValue = `linear-gradient(${bg.angle || 135}deg, ${bg.color1} ${bg.stop1}%, ${bg.color2} ${bg.stop2}%)`;
      }
    } else {
      backgroundValue = bg.color1;
    }
  }
  
  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        minHeight: '100vh',
        width: '100%',
        backgroundColor: 'transparent',
        position: 'relative'
      }}
    >
      {/* 1. Backdrop global (Dégradé ou couleur du thème) */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: backgroundValue,
          zIndex: -3,
          pointerEvents: 'none'
        }}
      />

      {/* 2. Arrière-plan 3D interactif */}
      <ThreeBackground />

      {/* 3. Contenu de la page */}
      <Box sx={{ position: 'relative', zIndex: 1 }}>
        {children}
      </Box>
    </Box>
  );
};

export default Layout;
